import React, { Component, Fragment } from 'react';
import { Button } from 'reactstrap';
import StartBrewModal from '~/containers/startBrewModal/startBrewModal';
import CompleteLotsModal from '~/containers/completeLotsModal/completeLotsModal';
import RenderWithPermission from '~/containers/renderWithPermission/renderWithPermission';
import { permissions } from '../../utils/permissions';

export default class StatCompleteLotButton extends Component {
  state = {
    startBrewModalOpen: false,
    completeBrewModalOpen: false
  };

  toggleStartBrewModal = () => {
    this.setState({
      startBrewModalOpen: !this.state.startBrewModalOpen
    });
  };

  toggleCompleteBrewModal = () => {
    this.setState({
      completeBrewModalOpen: !this.state.completeBrewModalOpen
    });
  };

  renderButton() {
    const { lot } = this.props;

    if (lot.status === 'PENDING') {
      return (
        <Button className="mr3" color="secondary" onClick={this.toggleStartBrewModal}>
          Start
        </Button>
      );
    }
    if (lot.status === 'IN_PROGRESS' && !lot.isConsolidated) {
      return (
        <RenderWithPermission permission={permissions.canCompleteLot}>
          <Button className="mr3" color="secondary" onClick={this.toggleCompleteBrewModal}>
            Confirm duty and complete
          </Button>
        </RenderWithPermission>
      );
    }
  }

  render() {
    const { lot } = this.props;
    const { startBrewModalOpen, completeBrewModalOpen } = this.state;
    if (!lot) {
      return null;
    }

    return (
      <Fragment>
        {this.renderButton()}
        <StartBrewModal
          lots={[lot]}
          isOpen={startBrewModalOpen}
          onSuccess={this.toggleStartBrewModal}
          onToggle={this.toggleStartBrewModal}
          refetchQueries={['lot']}
        />
        <CompleteLotsModal
          lots={[lot]}
          isOpen={completeBrewModalOpen}
          onSuccess={this.toggleCompleteBrewModal}
          onToggle={this.toggleCompleteBrewModal}
          refetchQueries={['lot']}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/lot/startCompleteButton.jsx